import styled from '@emotion/styled';

export const TextConfig = styled.div`
  @media (min-width: 1281px) {
    .font-48 {
      font-size: 48px;
    }

    .font-32 {
      font-size: 32px;
    }

    .font-28 {
      font-size: 28px;
    }

    .font-24 {
      font-size: 24px;
    }

    .font-20 {
      font-size: 20px;
    }
  }
  
  @media (min-width: 1025px) and (max-width: 1280px) {
    .font-48 {
      font-size: 44px;
    }

    .font-32 {
      font-size: 30px;
    }

    .font-28 {
      font-size: 26px;
    }

    .font-24 {
      font-size: 22px;
    }

    .font-20 {
      font-size: 20px;
    }
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    .font-48 {
      font-size: 40px;
    }

    .font-32 {
      font-size: 28px;
    }

    .font-28 {
      font-size: 24px;
    }

    .font-24 {
      font-size: 20px;
    }

    .font-20 {
      font-size: 18px;
    }
  }

  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    .font-48 {
      font-size: 36px;
    }

    .font-32 {
      font-size: 26px;
    }

    .font-28 {
      font-size: 22px;
    }

    .font-24 {
      font-size: 18px;
    }

    .font-20 {
      font-size: 18px;
    }
  }

  @media (min-width: 481px) and (max-width: 767px) {
    .font-48 {
      font-size: 32px;
    }

    .font-32 {
      font-size: 24px;
    }

    .font-28 {
      font-size: 20px;
    }

    .font-24 {
      font-size: 16px;
    }

    .font-20 {
      font-size: 14px;
    }
  }

  @media (min-width: 320px) and (max-width: 480px) {   
    .font-48 {
        font-size: 28px;
    }

    .font-32 {
      font-size: 22px;
    }

    .font-28 {
      font-size: 18px;
    }

    .font-24 {
      font-size: 14px;
    }

    .font-20 {
      font-size: 12px;
    }
  }
`;
